import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      transform="scale(0.4 0.4) translate(-2.5, -2.5)"
      d="M51.4584 10.8333H13.5417C11.3869 10.8333 9.32024 11.6893 7.79651 13.213C6.27277 14.7367 5.41675 16.8034 5.41675 18.9583V46.0416C5.41675 48.1965 6.27277 50.2631 7.79651 51.7868C9.32024 53.3106 11.3869 54.1666 13.5417 54.1666H51.4584C53.6133 54.1666 55.6799 53.3106 57.2037 51.7868C58.7274 50.2631 59.5834 48.1965 59.5834 46.0416V18.9583C59.5834 16.8034 58.7274 14.7367 57.2037 13.213C55.6799 11.6893 53.6133 10.8333 51.4584 10.8333ZM49.6438 16.2499L32.5001 29.1145L15.3563 16.2499H49.6438ZM51.4584 48.7499H13.5417C12.8235 48.7499 12.1346 48.4646 11.6267 47.9567C11.1188 47.4488 10.8334 46.7599 10.8334 46.0416V19.6353L30.8751 34.6666C31.3439 35.0182 31.9141 35.2083 32.5001 35.2083C33.0861 35.2083 33.6563 35.0182 34.1251 34.6666L54.1668 19.6353V46.0416C54.1668 46.7599 53.8814 47.4488 53.3735 47.9567C52.8656 48.4646 52.1767 48.7499 51.4584 48.7499Z"
      fill={fill}
    />
  </g>
);

export default Icon;
